import React from 'react';
import { ILocation } from 'types/location';

import Filter from './Filter';

const SearchAndFilterBar: React.FC<{ locations?: ILocation[] }> = ({ locations }) => (
  <div className='flex flex-col sm:flex-row items-center w-full'>
    <Filter locations={locations} />
  </div>
);

export default React.memo(SearchAndFilterBar);
